'use client'

import { FC, ReactNode, HTMLAttributes } from 'react'
import cn from 'classnames'
import { News } from '@/root/shared-types'
import { InfoIcon2 } from '@/root/ui/shared/icons/InfoIcon2'
import { WarningIcon } from '@/root/ui/shared/icons/WarningIcon'
import { truncateAtWord } from '@/root/shared-helpers/utils/utils'

interface HeroNotificationSlideProps extends HTMLAttributes<HTMLDivElement> {
  item: News
  icon?: ReactNode
}

export const HeroNotificationSlide: FC<HeroNotificationSlideProps> = ({ item, icon, className, ...props }) => {
  const normalizedSeverity = item.severity === 'alert' ? 'alert' : 'info'
  const isAlert = normalizedSeverity === 'alert'

  const text = truncateAtWord(item.subject ?? '', 50)

  return (
    <div className={cn('flex w-full min-w-0 items-center gap-2 font-semibold', className)} {...props}>
      <span className={cn('shrink-0', isAlert ? 'text-error' : 'text-primary-base')}>
        {icon ?? (isAlert ? <WarningIcon className="size-5" /> : <InfoIcon2 />)}
      </span>

      <span
        className={cn(
          'block w-full min-w-0 overflow-hidden text-left text-base underline',
          isAlert ? 'text-error' : 'text-primary-base'
        )}
        title={item.subject}
      >
        {text}
      </span>
    </div>
  )
}
